<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-ai drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-ai" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          AI Client
        </font>
        <v-spacer></v-spacer>
        <v-btn
          class="btn btn-save rounded-xl mr-2"
          :disabled="!$auth.manage || isDisableSave"
          v-if="!isHistory"
          @click="save"
          >{{ $t('btn.common.save') }}</v-btn
        >
        <v-btn
          class="btn btn-delete rounded-xl mr-2"
          :disabled="!$auth.manage || !formData.aiId"
          v-if="!isHistory"
          @click="deleteAIClient"
          >{{ $t('btn.common.delete') }}</v-btn
        >
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="12" class="px-3 py-0">
          <div class="d-flex justify-space-between align-center">
            <v-label class="pt-2">{{ $t('lbl.aiClient.aiClientName') }}</v-label>
            <div class="right-text">
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="copyData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-copy"
                />
              </v-btn>
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="clearData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-clear"
                />
              </v-btn>
            </div>
          </div>
          <v-combobox
            v-model="comId"
            :items="aiClientList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="aiId"
            item-text="aiNm"
            autofocus
            :maxlength="100"
            solo
            @change="changeComponentData()"
          >
          </v-combobox>
        </v-col>

        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.aiClient.type') }}
          </v-label>
          <v-select
            v-model="formData.aiTp"
            :items="aiTpCdList"
            :rules="[validationUtils.required]"
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-select>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0 flex justify-between">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.aiClient.apiEndpoint') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-text-field
            v-model="formData.aiEndpoint"
            :disabled="!$auth.manage"
            :rules="[validationUtils.required]"
            :readonly="isHistory"
            :maxlength="200"
            solo
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pl-3 pr-0 py-0 mb-4">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.aiClient.apiFormData') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="8" class=" pl-0 py-0 text-left">
          <v-icon @click="addFormData()" :disabled="!$auth.manage" :readonly="isHistory" dense dark
            >mdi-plus</v-icon
          >
        </v-col>
        <v-col cols="12" md="12" class="px-3 pb-4 pt-0">
          <v-row
            class="pt-0 pt-0 pb-1 edi-identification-right"
            v-for="(item, i) in formData.listFormData"
            :key="item.id"
          >
            <v-col lg="4" class="pl-3 pr-2 py-0">
              <v-text-field
                :ref="'FD_' + item.id"
                :maxlength="200"
                solo
                hide-details
                placeholder="Key"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                v-model="item.key"
              ></v-text-field>
            </v-col>
            <v-col lg="7" class="pl-2 pr-2 py-0">
              <v-text-field
                :ref="'FD_' + item.id + '_' + item.id"
                :maxlength="200"
                solo
                hide-details
                placeholder="Value"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                v-model="item.value"
              ></v-text-field>
            </v-col>
            <v-col lg="1" class="pa-0 pr-3 mr-0 mt-2">
              <v-icon
                @click="removeFormData(i)"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                dense
                class="ml-1"
                dark
                >mdi-minus</v-icon
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4" class="pl-3 pr-0 py-0 mb-4">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.aiClient.apiHeader') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="8" class=" pl-0 py-0 text-left">
          <v-icon @click="addHeader()" :disabled="!$auth.manage" :readonly="isHistory" dense dark
            >mdi-plus</v-icon
          >
        </v-col>
        <v-col cols="12" md="12" class="px-3 pb-4 pt-0">
          <v-row
            class="pt-0 pt-0 pb-1 edi-identification-right"
            v-for="(item, i) in formData.listHeader"
            :key="item.id"
          >
            <v-col lg="4" class="pl-3 pr-2 py-0">
              <v-text-field
                :ref="'HEADER_' + item.id"
                :maxlength="200"
                solo
                hide-details
                placeholder="Key"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                v-model="item.key"
              ></v-text-field>
            </v-col>
            <v-col lg="7" class="pl-2 pr-2 py-0">
              <v-text-field
                :ref="'HEADER_' + item.id + '_' + item.id"
                :maxlength="200"
                solo
                hide-details
                placeholder="Value"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                v-model="item.value"
              ></v-text-field>
            </v-col>
            <v-col lg="1" class="pa-0 pr-3 mr-0 mt-2">
              <v-icon
                @click="removeHeader(i)"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                dense
                class="ml-1"
                dark
                >mdi-minus</v-icon
              >
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0 flex justify-between">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.aiClient.dataPathOfAPIResult') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-text-field
            v-model="formData.aiFooter"
            :disabled="!$auth.manage"
            :rules="[validationUtils.required]"
            :readonly="isHistory"
            :maxlength="200"
            solo
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="AlertAIClientSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertAIClientSetup.dialog = false"
    >
    </dialogWindow>
    <dialogWindow
      ref="RegisteredSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['AI Client', 'created'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['AI Client', 'modified'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="deleteAI"
      title="Delete AI Client"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['AI Client'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Merge & Compare"
      :detail="add_valid_str"
      color="warning"
    ></dialogWindow>
    <dialogWindow
      ref="errorDialog"
      size="max"
      title="Merge & Compare"
      :detail="add_valid_str"
      color="error"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { getEditData } from '@/vue-caas/utils/process';
import cfg from '@/vue-caas/config/config.js';
import { runSave } from '@/vue-caas/views/processnew/component/saveRunner.js';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'AI',
      formData: {
        byProcSetup: true,
        aiId: '',
        aiNm: '',
        aiTp: '',
        listUserData: [],
        listFormData: [],
        listHeader: [],
        aiEndpoint: '',
        aiFooter: '',
        aiFormData: '',
        aiHeader: '',
      },
      loadFormData: {
        byProcSetup: true,
        aiId: '',
        aiNm: '',
        aiTp: '',
        listUserData: [],
        listFormData: [],
        listHeader: [],
        aiEndpoint: '',
        aiFooter: '',
        aiFormData: '',
        aiHeader: '',
      },
      add_valid_str: '',
      aiTpCdList: [],
      checkDialogInfo: '',
      checkDialogColor: 'warning',
      isDisableSave: false,
    };
  },
  created() {
    this.initialize();
    console.log(this.comId);
    EventBus.$on('check-right-layer-change', this.closeComDialog);
    EventBus.$on('updateFormData', this.updateFormData);
  },
  methods: {
    copyData() {
      this.formData.aiId = '';
      this.formData.aiNm = '';
      this.comId = '';
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    clearData() {
      this.changeAIClient('');
      this.comId = '';
    },
    changeComponentData() {
      if (this.comId && this.comId.value) {
        this.changeAIClient(this.comId.value);
      } else {
        if (this.formData.aiId) {
          this.changeAIClient('');
        }
        this.formData.aiNm = this.comId;
      }
      this.checkAIClientName();
    },
    resetForm() {
      this.formData = {
        byProcSetup: true,
        aiId: '',
        aiNm: '',
        aiTp: '',
        listUserData: [],
        listFormData: [],
        listHeader: [],
        aiEndpoint: '',
        aiFooter: '',
        aiFormData: '',
        aiHeader: '',
      };
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    updateFormData(data) {
      if (this.nodeId === data.nodeInfo) this.resetForm();
      return;
    },
    addFormData() {
      let i =
        this.formData.listFormData.length > 0
          ? this.formData.listFormData[this.formData.listFormData.length - 1].id + 1
          : 1;
      let obj = {
        id: i,
        key: '',
        value: '',
      };
      this.formData.listFormData.push(obj);
    },
    addHeader() {
      let i =
        this.formData.listHeader.length > 0
          ? this.formData.listHeader[this.formData.listHeader.length - 1].id + 1
          : 1;
      let obj = {
        id: i,
        key: '',
        value: '',
      };
      this.formData.listHeader.push(obj);
    },
    removeFormData(i) {
      this.formData.listFormData.splice(i, 1);
    },
    removeHeader(i) {
      this.formData.listHeader.splice(i, 1);
    },
    checkAIClientName() {
      this.aiClientList.map((e) => {
        if (e.text === this.formData.aiNm && e.aiId !== this.formData.aiId) {
          this.formData.aiNm = '';
          this.comId = '';
          this.checkDialogInfo = `AI Client name : ${e.text} have been created !`;
          this.checkDialogColor = 'warning';
          this.$refs.AlertAIClientSetup.dialog = true;
          return;
        }
      });
    },
    initialize() {
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.aiTpCdList = this.options.item.data.aiTpCdList;
      this.changeAIClient(this.options.item.data.comId);
    },
    changeAIClient(id) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      let index = this.aiClientList.findIndex((e) => e.aiId == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        let data = this.aiClientList[index];
        data.listFormData = [];
        data.listHeader = [];

        if (data.aiFormData !== '') {
          let arrFormData = data.aiFormData.replace(/"/g, '').split(',');
          for (let j = 0; j < arrFormData.length; j += 2) {
            data.listFormData.push({
              id: j / 2,
              key: arrFormData[j],
              value: arrFormData[j + 1],
            });
          }
        }

        if (data.aiHeader !== '') {
          let arrHeader = data.aiHeader.replace(/"/g, '').split(',');
          for (let j = 0; j < arrHeader.length; j += 2) {
            data.listHeader.push({
              id: j / 2,
              key: arrHeader[j],
              value: arrHeader[j + 1],
            });
          }
        }

        this.formData = Object.assign({}, data);
        this.loadFormData = Object.assign({}, data);
        this.formData.byProcSetup = true;
        this.loadFormData.byProcSetup = true;
        this.comId = Object.assign({}, data);
        EventBus.$emit('change-component-data', id, this.nodeId);
      } else {
        this.resetForm();
      }
    },
    closeComDialog() {
      this.checkDataChange();
    },

    async save() {
      const result = await runSave(this, 'AI', { mode: 'form', data: this.formData });
      if (!result.success) {
        console.log(result.message);
      }
    },
    actionDel() {
      let self = this;
      this.$store.dispatch('deleteAIClient', { aiId: this.formData.aiId }).then(() => {
        this.$store.dispatch('getAIClientSelectBoxList').then((res) => {
          this.$refs.form.resetValidation();
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'AI') {
              if (comp.formData.aiId === self.formData.aiId) {
                comp.resetForm();
              }
            }
          });
          this.comId = '';
          this.changeAIClient('');
        });
      });
    },
    deleteAIClient() {
      if (cfg.isDlb) {
        this.$refs.deleteAI.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', {
            type: 'AI',
            value: this.formData.aiId,
          })
          .then((res) => {
            if (res.length > 0) {
              EventBus.$emit('openDelHistoryWorkflowDialog', res, this.formData, this.nodeId);
            } else {
              this.$refs.deleteAI.dialog = true;
            }
          });
      }
    },
    checkDataChange() {
      this.formData.byProcSetup = true;

      this.formData.aiFormData = '';
      let aiFormData = '';

      this.formData.listFormData.map((e) => {
        aiFormData += `"${e.key}","${e.value}",`;
      });

      aiFormData = aiFormData.slice(0, aiFormData.length - 1);
      this.formData.aiFormData = aiFormData;
      this.formData.aiHeader = '';
      let aiHeader = '';
      this.formData.listHeader.map((e) => {
        aiHeader += `"${e.key}","${e.value}",`;
      });

      aiHeader = aiHeader.slice(0, aiHeader.length - 1);
      this.formData.aiHeader = aiHeader;
      let editedData = getEditData(this.formData, this.loadFormData);
      if (Object.keys(editedData).length !== 0) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  computed: {
    aiClientList() {
      return this.$store.getters.aiClientSelectBoxList;
    },
  },
};
</script>

<style></style>
